import { alertService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, alerts: [], alert: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        alertService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        alertService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/alerts');
                    dispatch('alert/success', "Alert Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/alerts');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        alertService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/alerts');
                    dispatch('alert/success', "Alert Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/alerts');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        alertService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      alertService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/alerts');
                  dispatch('alert/success', "Alert Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/alerts');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_custom_alerts_by_account({ dispatch, commit }, data) {
        commit('request');

        alertService.get_custom_alerts_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  alerts: state => {
    return state.alerts
  },
  alert: state => {
    return state.alert
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.alert = {};
        state.alerts = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.alert = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.alerts = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const alerts = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
